import axios from 'axios'

const parametros = {
    getParamsGenerales: () => axios.get("parametros/generales"),
};
export default parametros
